import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import cn from 'classnames'
import {hideModal, RENDER_BODY, defaultZindex} from '../../../modules/modals'
import {LOADER_BAR_COLOR, LOADER_BAR_MODAL_SCOPE} from '../../../settings/constants'
import { connect } from 'react-redux'
import LoadingBar, {showLoading, hideLoading} from 'react-redux-loading-bar'


class RenderBody extends Component {
    render() {
        const {zIndex, render, title, titleClassName = "", modalClassName, bodyClassName, hideLoading, showLoading} = this.props
        return (
            <Modal
                isOpen = {true}
                style = {{
                    overlay : {zIndex},
                }}
                onRequestClose={this.handleClose}
                overlayClassName = "custom-modal"
                className = {cn("custom-modal-content create-dialog-modal-content", modalClassName)}
            >
                <div className="posr">
                    <div className="loader-bar-wrapper-absolute">
                        <LoadingBar scope={LOADER_BAR_MODAL_SCOPE} style={{backgroundColor: LOADER_BAR_COLOR}} />
                    </div>
                </div>
                <div className="create-dialog-modal-content__header">
                    {
                        title &&
                        <div className={cn("create-dialog-modal-content__title", titleClassName)}>{title}</div>
                    }
                    <div
                        onClick={this.handleClose}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className={cn("create-dialog-modal-content__body", bodyClassName)}>
                    {
                        render({
                            handleClose : this.handleClose,
                            // added just in case
                            hideLoading : () => hideLoading('modal'),
                            showLoading : () => showLoading('modal'),
                        })
                    }
                </div>
            </Modal>
        )
    }

    handleClose = () => {
        let {handleClose, hideModal, modalType} = this.props
        if (typeof handleClose === 'function') {
            handleClose()
        } else {
            hideModal({ modalType})
        }
    }

    static contextTypes = {formatMessage: PropTypes.func}
    static propTypes = {
        render : PropTypes.func.isRequired,
        hideModal : PropTypes.func.isRequired,
        handleClose : PropTypes.func,
        zIndex : PropTypes.number,
        title : PropTypes.string,
        modalType : PropTypes.string,
        modalClassName : PropTypes.string,
        bodyClassName : PropTypes.string,
    }
    static defaultProps = {
        zIndex : defaultZindex,
        title : "",
        modalType : RENDER_BODY,
        modalClassName : "",
        bodyClassName : "",
    }
}

export default connect(
    null,
    {hideModal, hideLoading, showLoading}
)(RenderBody)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/RenderBody.js